module.exports = __webpack_public_path__ + "img/bg-result.31790c0a.png";